import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';
import mixins from '../../../../styles/mixins';

export const useStyles = makeStyles<Theme>()((theme) => ({
  commentWrapper: {
    borderRadius: 4,
    padding: 8,
    display: 'flex',
    width: '100%',
    ...mixins.appSvg,
  },
  left: {},
  right: {
    flex: 1,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  userInfo: {
    marginLeft: 8,
    display: 'flex',
    flexDirection: 'column',
  },
  editedCommentContent: {},
  editedCommentBottom: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 8,
  },
  uploadFileButton: {
    height: 32,
    lineHeight: '24px',
    padding: '4px 8px',
    display: 'inline-flex',
    marginBottom: 4,
    '& svg': {
      marginRight: 8,
    },
  },

  filesWrapper: {
    marginTop: 8,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  repliedCommentWrapper: {
    borderLeft: `${theme.palette.primary.main} 2px solid`,
  },

  footer: {
    marginTop: 8,
    '& svg + svg': {
      marginLeft: 16,
    },
  },
  createdAt: {
    color: theme.palette.grey[600],
  },
}));
